module.exports = __webpack_public_path__ + "static/media/Jan_2026_2.57cfe43f.webp";